import { http } from "../client";
import { mapUserResponse } from "./mappers";
var isLoginFailure = function (error) { var _a, _b; return (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors; };
export var login = function (user) {
    return http.base
        .post("/login", user)
        .then(function (_a) {
        var data = _a.data;
        return ({
            type: "success",
            payload: mapUserResponse(data),
        });
    })
        .catch(function (error) {
        if (!isLoginFailure(error)) {
            throw Error("");
        }
        return {
            type: "failure",
            payload: error.response.data.errors,
        };
    });
};
